module.exports = __webpack_public_path__ + "mc.svg?32dc11e1be58917ca434dde32dbb5615";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mc.svg
// module id = 1064
// module chunks = 27